import Navbar from './components/nav-bar'
import AboutUs from './components/about-us'
import Brands from './components/brands'
import Contact from './components/contact'
import Footer from './components/footer'
import { SnackbarProvider } from 'notistack'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import './styles.css'

const theme = createTheme({
  palette: {
    primary: {
      main: '#000',
    },
    secondary: {
      main: '#fff',
      styleOverrides: { root: { textTransform: 'none' } },
    },
  },
  typography: { fontFamily: 'Gothic' },
})

function App() {
  return (
    <SnackbarProvider>
      <ThemeProvider theme={theme}>
        <Navbar />
        <AboutUs />
        <Brands />
        <Contact />
        <Footer />
      </ThemeProvider>
    </SnackbarProvider>
  )
}

export default App
